$ = require 'jquery'
OrganizationListItemView = require 'views/organization/organization-list-item-view'
View = require 'view'

module.exports = class OrganizationListView extends View
  tagName: 'ul'

  className: 'org-list'

  initialize: (args) ->
    @listenTo @model.organizationList,
      'add remove reset change:closed': @frameDebounce @render
    return

  render: ->
    @$el.empty()

    subviews = @model.getSortedOrgs().map (org) =>
      @subview OrganizationListItemView, org

    @appendSubviews subviews

    @



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-list-view.coffee